
import { css } from 'lit';
export default css`
:host{
  display:block;
  width:100%;
  z-index:3;
}

details summary::-webkit-details-marker{
  display:none;
}

summary.label{
  list-style:none;
  display:inline-flex;
  justify-content:space-between;
  align-items:center;
  cursor:pointer;
  box-sizing:border-box;
  border-top:2px solid var(--purple-medium-neutral);
  padding:var(--spacing-5) var(--spacing-8);
  min-width:100%;
  color:var(--neutral-charcoal);
  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5);
  text-wrap:nowrap;
  font-weight:var(--fw-medium);
}

:host([active-filters='0']) summary.label{
  font-weight:var(--fw-normal);
}

summary.label:hover,
details[open] summary.label{
  border-color:var(--purple-indigo);
  color:var(--purple-indigo);
  font-weight:var(--fw-medium);
}

details[open] summary.label pc-icon{
  display:block;
  transform:rotate(180deg);
}

.active-filter{
  display:inline-flex;
  justify-content:center;
  align-items:center;
  border-radius:100px;
  background-color:var(--purple-indigo);
  width:19px;
  height:19px;
  color:var(--primary-white);
  font-size:var(--fs-caption);
}

.content{
  z-index:1;
  padding-right:var(--spacing-8);
  padding-bottom:var(--spacing-5);
}

@media (min-width: 768px){

  details[open]{
    position:relative;
  }



  summary.label{
    border:2px solid var(--purple-medium-neutral);
    border-radius:var(--spacing-2);
    padding:calc(var(--spacing-2) - 2px) var(--spacing-4);
    font-size:var(--fs-body);
    line-height:var(--lh-body);
    background-color:white;
    transition:all ease-in 300ms;
    gap:var(--spacing-4);
    color:var(--purple-indigo);
  }

  summary.label:hover,
  details[open] summary.label{
    border-color:var(--purple-indigo);
    background-color:var(--purple-indigo);
    color:var(--primary-white);
  }

  .content{
    position:absolute;
    margin-top:var(--spacing-2);
    box-shadow:0px 4px 8px 0px rgba(91, 73, 108, 0.2);
    border-radius:var(--spacing-2);
    background-color:var(--primary-white);
    padding-right:var(--spacing-2);
    padding-bottom:var(--spacing-4);
    left:0;
    right:0;
  }

  .search pc-icon{
    left:var(--spacing-6);
  }
}
`;